/*-----------------------------------------------------------------
- Export components
-----------------------------------------------------------------*/
/**
 * Capitalize text
 * 
 * @param {*} string
 * @returns {string}
 */
const capitalize = (string) => {
    if (typeof string !== 'string') {
        return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Clear text and upper case
 *
 * @param {*} text
 * @returns {string}
 */
const clearAndUpper = (text) => text.replace(/-/, '').replace(/_/, '').toUpperCase();

/**
 * Convert to camel case
 *
 * @param {*} text
 * @returns {*}
 */
const toCamelCase = (text) => text.replace(/-\w/g, clearAndUpper).replace(/_\w/g, clearAndUpper);

const components: any = {};

// Load files
const importedFiles = require.context('@groot-components/', true, /\.vue$/);

// Merge configs
importedFiles.keys().forEach((fileName) => {
    const file = importedFiles(fileName).default;
    const name = toCamelCase(capitalize(fileName.split('/')[1].replace('.vue', '')));

    if(!components[name]) {
        components[name] = file;
    }
});

// Export all components
export const YAccordion = components.Accordion;
export const YAccordionItem = components.AccordionItem;
export const YAlert = components.Alert;
export const YBadge = components.Badge;
export const YBreadcrumb = components.Breadcrumb;
export const YButton = components.Button;
export const YButtonGroup = components.ButtonGroup;
export const YCheckbox = components.Checkbox;
export const YChips = components.Chips;
export const YCloner = components.Cloner;
export const YCol = components.Col;
export const YContainer = components.Container;
export const YCopyValue = components.CopyValue;
export const YDatePicker = components.DatePicker;
export const YDivision = components.Division;
export const YDropdown = components.Dropdown;
export const YDropdownItem = components.DropdownItem;
export const YEditor = components.Editor;
export const YEmpty = components.Empty;
export const YFieldWrapper = components.FieldWrapper;
export const YForm = components.Form;
export const YGoftino = components.Goftino;
export const YIcon = components.Icon;
export const YImage = components.Image;
export const YInput = components.Input;
export const YLoadMore = components.LoadMore;
export const YLoading = components.Loading;
export const YLoop = components.Loop;
export const YMap = components.Map;
export const YMenu = components.Menu;
export const YMenuItem = components.MenuItem;
export const YModal = components.Modal;
export const YPageContent = components.PageContent;
export const YPagination = components.Pagination;
export const YPanel = components.Panel;
export const YPhone = components.Phone;
export const YPlayer = components.Player;
export const YRadio = components.Radio;
export const YRange = components.Range;
export const YRayChat = components.RayChat;
export const YRecaptcha = components.Recaptcha;
export const YRow = components.Row;
export const YSelect = components.Select;
export const YSelectFlag = components.SelectFlag;
export const YSelectMap = components.SelectMap;
export const YSeo = components.Seo;
export const YSlide = components.Slide;
export const YSlideshow = components.Slideshow;
export const YSocials = components.Socials;
export const YStepper = components.Stepper;
export const YTab = components.Tab;
export const YTable = components.Table;
export const YTextarea = components.Textarea;
export const YToggle = components.Toggle;
export const YTreeSelect = components.TreeSelect;
export const YUploader = components.Uploader;
export const YValidator = components.Validator;

export {
    components
};
